import {
    GET_ZONES,
    GET_ZONES_SUCCESS,
    GET_ZONES_FAIL,
    ADD_ZONE,
    ADD_ZONE_SUCCESS,
    ADD_ZONE_FAIL,
    UPDATE_ZONE,
    UPDATE_ZONE_SUCCESS,
    UPDATE_ZONE_FAIL,
    DELETE_ZONE,
    DELETE_ZONE_SUCCESS,
    DELETE_ZONE_FAIL,
    SET_ZONE_FIELD_ERRORS,
  } from './actionTypes';
  
  // Get Zones
  export const getZones = () => ({
    type: GET_ZONES,
  });
  
  export const getZonesSuccess = (zones) => ({
    type: GET_ZONES_SUCCESS,
    payload: zones,
  });
  
  export const getZonesFail = (error) => ({
    type: GET_ZONES_FAIL,
    payload: error,
  });
  
  // Add Zone
  export const addZone = (zone, navigate) => ({
    type: ADD_ZONE,
    payload: { zone, navigate }, // { sp: "usp_InsertZone", zoneName: "zoneD" }
  });
  
  export const addZoneSuccess = (zone) => ({
    type: ADD_ZONE_SUCCESS,
    payload: zone,
  });
  
  export const addZoneFail = (error) => ({
    type: ADD_ZONE_FAIL,
    payload: error,
  });
  
  // Update Zone
  export const updateZone = (zone, navigate) => ({
    type: UPDATE_ZONE,
    payload: { zone, navigate },
  });
  
  export const updateZoneSuccess = (zone) => ({
    type: UPDATE_ZONE_SUCCESS,
    payload: zone,
  });
  
  export const updateZoneFail = (error) => ({
    type: UPDATE_ZONE_FAIL,
    payload: error,
  });
  
  // Delete Zone
  export const deleteZone = (id) => ({
    type: DELETE_ZONE,
    payload: id,
  });
  
  export const deleteZoneSuccess = (id) => ({
    type: DELETE_ZONE_SUCCESS,
    payload: id,
  });
  
  export const deleteZoneFail = (error) => ({
    type: DELETE_ZONE_FAIL,
    payload: error,
  });
  
  // Set Field Errors
  export const setZoneFieldErrors = (errors) => ({
    type: SET_ZONE_FIELD_ERRORS,
    payload: errors,
  });